import lsApi from "../api/lsApi";
import { useAppSelector } from '../redux/hooks';
import { ICreateDeleteCodeResponse, IMotive, IVerifyCodeResponse, IHistoryAccessCode, IHistoryReservaciones, IHistoryIncidentes, IHistoryIncidentesMessages, IHistoryAccessCodeFrecuente } from '../models/codes';

export default function useAccessCode() {

    const userData = useAppSelector((state) => state.auth.userData)

    const createAccessCode = async (nombre: string, motivo: string, fecha: string, fechaAbierta: number, limite: number, nota: string) => {

        const { agencia, casa, empresa, usuario } = userData!

        try {
            const { data, status } = await lsApi.post<ICreateDeleteCodeResponse>('/api/ControlAcceso/CrearAcceso', {
                empresa,
                agencia,
                id_casa: casa,
                nombre_Visita: nombre,
                motivo_Visita: motivo,
                fecha_Visita: fecha,
                fecha_Abierta: fechaAbierta,
                nota: nota,
                usuario: usuario,
                limite: limite,
                uuid: `acb3f5c0-5b9f-11eb-ae93-0242ac130002`,
            })

            if (status === 200) {
                return data
            }
            else {
                return false
            }

        }
        catch (error) {
            return false
        }

    }

    const deleteAccessCode = async (codigo: string) => {

        const { agencia, casa, empresa, usuario } = userData!

        try {
            const { data, status } = await lsApi.delete<ICreateDeleteCodeResponse>('/api/ControlAcceso/AnularCodigoAcceso', {
                data: {
                    empresa,
                    agencia,
                    codigo_Acceso: codigo,
                    id_casa: casa,
                    usuario: usuario,
                },
                headers: {
                    'Content-Type': 'application/json'
                }
            })

            if (status === 200) {
                return data
            }
            else {
                return false;
            }
        }
        catch (error) {
            console.log(error)
            return false
        }

    }

    const deleteAccessCodeFrecuente = async (codigo: string) => {

        const { agencia, casa, empresa, usuario } = userData!

        try {
            const { data, status } = await lsApi.delete<ICreateDeleteCodeResponse>('/api/ControlAcceso/AnularCodigoAccesoFrecuente', {
                data: {
                    empresa,
                    agencia,
                    codigo_Acceso: codigo,
                    id_casa: casa,
                    usuario: usuario,
                },
                headers: {
                    'Content-Type': 'application/json'
                }
            })

            if (status === 200) {
                return data
            }
            else {
                return false;
            }
        }
        catch (error) {
            console.log(error)
            return false
        }

    }

    const validateAccessCode = async (codigo: string) => {

        const { agencia, casa, empresa, usuario } = userData!

        try {
            const { data, status } = await lsApi.put<IVerifyCodeResponse>('/api/ControlAcceso/ValidarCodigoAcceso', {
                empresa,
                agencia,
                codigo_Acceso: codigo,
                usuario: usuario,
                id_casa: casa,
            })

            if (status === 200) {
                return data
            }
            else {
                return false
            }
        }
        catch (error) {
            console.log(error)
            return false
        }

    }

    const verifyAccesCode = async (correlativo: number, placa: string, vehiculo: string, color: string, documento: string, accessCode?: string) => {

        const { agencia, empresa, usuario } = userData!
        const isFrecuente = accessCode && accessCode.startsWith('F')

        try {
            const body: any = {
                entrada: true,
                empresa,
                agencia,
                correlativo,
                placa,
                vehiculo,
                color,
                documento,
                usuario,
            }

            if (isFrecuente) {
                body.CodigoAcceso = accessCode
            }

            const { data, status } = await lsApi.put<ICreateDeleteCodeResponse>('/api/ControlAcceso/AceptarEntradaSalida', body)

            if (status === 200) {
                return data
            }
            else {
                return false
            }
        }
        catch (error) {
            console.log(error)
            return false
        }
    }

    const giveEgress = async (correlativo: number, placa: string, vehiculo: string, color: string, documento: string) => {

        const { agencia, empresa, usuario } = userData!

        try {
            const { data, status } = await lsApi.put<ICreateDeleteCodeResponse>('/api/ControlAcceso/AceptarEntradaSalida', {
                entrada: false,
                empresa,
                agencia,
                correlativo,
                placa,
                vehiculo,
                color,
                documento,
                usuario,
            })

            if (status === 200) {
                return data
            }
            else {
                return false
            }
        }
        catch (error) {
            console.log(error)
            return false
        }
    }

    const getMotives = async () => {

        const { empresa } = userData!

        try {
            const { data, status } = await lsApi.get<IMotive[]>(`/api/ControlAcceso/CatalogoTipoMotivo?Empresa=${empresa}`)
            if (status === 200) {
                return data
            }
            else {
                return false
            }
        }
        catch (error) {
            return false
        }

    }

    const getHistory = async () => {

        try {
            const { data, status } = await lsApi.get<IHistoryAccessCode[]>(`/api/ControlAcceso/ListadoCodigoAcceso`)
            if (status === 200) {
                return data
            }
            else {
                return false
            }
        }
        catch (error) {
            return false
        }
    }

    const getHistoryFrecuente = async () => {

        try {
            const { data, status } = await lsApi.get<IHistoryAccessCodeFrecuente[]>(`/api/ControlAcceso/ListadoCodigosFrecuentes`)
            if (status === 200) {
                return data
            }
            else {
                return false
            }
        }
        catch (error) {
            return false
        }
    }

    const getHistoryEgress = async () => {

        try {
            const { data, status } = await lsApi.get<IHistoryAccessCode[]>(`/api/ControlAcceso/EgresoGarita`)
            if (status === 200) {
                return data
            }
            else {
                return false
            }
        }
        catch (error) {
            return false
        }
    }

    const getHistoryReservas = async () => {

        try {
            const { data, status } = await lsApi.get<IHistoryReservaciones[]>(`/api/ControlAcceso/ListadoReservaciones`)
            if (status === 200) {
                return data
            }
            else {
                return false
            }
        }
        catch (error) {
            return false
        }
    }

    const getHistoryReservasAdmin = async () => {

        try {
            const { data, status } = await lsApi.get<IHistoryReservaciones[]>(`/api/ControlAcceso/ReservacionesAdmin`)
            if (status === 200) {
                return data
            }
            else {
                return false
            }
        }
        catch (error) {
            return false
        }
    }
    const deleteReserva = async (reserva: IHistoryReservaciones) => {


        try {
            const { data, status } = await lsApi.put<ICreateDeleteCodeResponse>(
                '/api/ControlAcceso/AnularReservaAmenidad',
                reserva,
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            )

            if (status === 200) {
                return data
            }
            else {
                return false;
            }
        }
        catch (error) {
            console.log(error)
            return false
        }

    }

    const getHistoryIncidentes = async () => {

        try {
            const { data, status } = await lsApi.get<IHistoryIncidentes[]>(`/api/ControlAcceso/ListadoIncidentes`)
            if (status === 200) {
                return data
            }
            else {
                return false
            }
        }
        catch (error) {
            return false
        }
    }

    const getMessagesTicket = async (inTicket: number) => {

        try {
            const { data, status } = await lsApi.get<IHistoryIncidentesMessages[]>(`/api/ControlAcceso/MensajesTicket?INTICKET=${inTicket}`)
            if (status === 200) {
                return data
            }
            else {
                return false
            }
        }
        catch (error) {
            return false
        }
    }

    /**
     * Envía un mensaje a un ticket de incidente
     * @param req { usuario, empresa, ticket, nota }
     */
    const sendMessageTicket = async (req: { Usuario: string, Empresa: number, Ticket: number, Nota: string }) => {
        try {
            const { data, status } = await lsApi.post('/api/ControlAcceso/EnviarMensajeTicket', req);
            if (status === 200) {
                return data;
            } else {
                return false;
            }
        } catch (error) {
            return false;
        }
    };

    const getMotivosAnulacion = async () => {
        try {
            const { data, status } = await lsApi.get('/api/ControlAcceso/GetCatalogoAnulacion');
            if (status === 200) {
                return data;
            } else {
                return false;
            }
        } catch (error) {
            return false;
        }
    }


    const crearAccesoFrecuente = async (formAccesoFrecuente: FormData) => {

        try {
            const { data, status } = await lsApi.post('/api/Core/RegistrarAccesoFrecuente', formAccesoFrecuente, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })

            if (status === 200) {
                return data
            }
            else {
                return false
            }

        }
        catch (error) {
            return false
        }

    }

    const actualizarAccesoFrecuente = async (accesoFrecuente: IHistoryAccessCodeFrecuente) => {
        const { agencia, empresa, usuario } = userData!

        // Convertir valores booleanos/números a números (0 o 1)
        const convertToNumber = (value: boolean | number): number => {
            if (typeof value === 'boolean') {
                return value ? 1 : 0;
            }
            return value ? 1 : 0;
        }

        const accesoParaAPI = {
            ...accesoFrecuente,
            lunes: convertToNumber(accesoFrecuente.lunes),
            martes: convertToNumber(accesoFrecuente.martes),
            miercoles: convertToNumber(accesoFrecuente.miercoles),
            jueves: convertToNumber(accesoFrecuente.jueves),
            viernes: convertToNumber(accesoFrecuente.viernes),
            sabado: convertToNumber(accesoFrecuente.sabado),
            domingo: convertToNumber(accesoFrecuente.domingo),
            empresa,
            agencia,
            usuario
        }



        try {
            const { data, status } = await lsApi.put('/api/ControlAcceso/ActualizarAccesoFrecuente', accesoParaAPI, {
                headers: {
                    'Content-Type': 'application/json'
                }
            })

            if (status === 200) {
                return data
            }
            else {
                return false
            }

        }
        catch (error) {
            return false
        }
    }


    return {
        createAccessCode,
        deleteAccessCode,
        deleteAccessCodeFrecuente,
        validateAccessCode,
        verifyAccesCode,
        getMotives,
        getHistory,
        getHistoryEgress,
        giveEgress,
        getHistoryReservas,
        deleteReserva,
        getHistoryIncidentes,
        getMessagesTicket,
        sendMessageTicket,
        getHistoryReservasAdmin,
        getMotivosAnulacion,
        getHistoryFrecuente,
        crearAccesoFrecuente,
        actualizarAccesoFrecuente
    }



}

